"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";

/** Error boundary zona (auth) — form login/daftar fallback. */
export default function AuthZoneError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[auth-zone]", error);
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <h2 className="text-foreground text-lg font-bold">
        Halaman autentikasi gagal dimuat
      </h2>
      <p className="text-muted-foreground text-sm">Coba muat ulang halaman ini.</p>
      <div className="flex gap-3">
        <Button size="xl" onClick={reset}>
          Coba lagi
        </Button>
        <Button size="xl" variant="outline" render={<Link href="/masuk" />}>
          Ke halaman masuk
        </Button>
      </div>
    </div>
  );
}
